export default {
  appVersion: process.env.REACT_APP_APP_VERSION || "development",
  googleAnalyticsId:
    process.env.REACT_APP_GOOGLE_ANALYTICS_ID || "UA-XXXXXXX-X",
  apiHost: process.env.REACT_APP_API_HOST || "http://localhost:3000",

  sentryUrl: process.env.REACT_APP_SENTRY_URL || ""
};



// WEBPACK FOOTER //
// ./src/config/config.js